export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.18-1049.27",
  commitId: "722704757fae195fe3efe6be85b74b5daf54e51c",
  commitTime: "2026-09-18T10:49:27.000Z",
});
